module.exports = __webpack_public_path__ + "img/image-slider-01.1d8f3be3.png";